export default __webpack_public_path__ + "static/backgroundContact-3aa5753f502e60fd6585cdf653492f15.webp";